import { connect } from 'react-redux';

import AppComponent from '../components/App';

import { checkSession } from '../actions/auth';

import {
  messageSelector,
  typeSelector,
  shouldShowNotieSelector,
} from '../reducers/notie';

import {
  isAuthenticatedSelector,
  isBootingSessionSelector,
} from '../reducers/auth';

import {
  isLoadingSelector,
} from '../reducers';

const mapStateToProps = state => {
  return {
    isAuthenticated: isAuthenticatedSelector(state),
    isBootingSession: isBootingSessionSelector(state),
    shouldShowNotie: shouldShowNotieSelector(state),
    notieType: typeSelector(state),
    notieMessage: messageSelector(state),
    loading: isLoadingSelector(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    checkSession: () => dispatch(checkSession()),
  };
};

const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);

export default App;

